import { CollectionGroup, Document, UserProfile } from "../../models"
import { UserCollectionsState } from "../../redux"
import { CustomInputMapping } from "../../redux/data/globalData/customInputMapping/customInputMappingActions";

export const isUserItemAuthor = (document: Document, userUid: string): boolean => {
    return userUid === document.userUUID
}

export const isUserMemberOnItem = (document: Document, userUid: string): boolean => {
    if (document.members) {
        const member = document.members.find(member => member.userUUID === userUid)
        return !!member
    }

    return false
}

export const isUserOrgAdmin = (profileData: UserProfile): boolean => {
    return profileData.role === 'Admin'
}

export const isUserOrgViewer = (profileData: UserProfile): boolean => {
    return profileData.role === 'Viewer'
}

export const isUserAdminOnGroupItem = (document: Document, profileData: UserProfile, userCollectionsState: UserCollectionsState): boolean => {
    const group = getGroupByItem(document, userCollectionsState)

    if (group) {
        return group.adminUIds.includes(profileData.auth0_id)
    }

    return false
}

export const doesUserHavePermissionOnGroupItem = (document: Document, userCollectionsState: UserCollectionsState): boolean => {
    const group = getGroupByItem(document, userCollectionsState)

    if (group) {
        return group.isEnableMembersAsAuthors
    }

    return false
}

const getGroupByItem = (document: Document, userCollectionsState: UserCollectionsState): CollectionGroup | null | undefined => {
    let group = null

    if (document.groupUid && userCollectionsState.data) {
        const itemCollection = userCollectionsState.data.find(c => c.collectionGroup.groupUid === document.groupUid)

        group = itemCollection && itemCollection.collectionGroup
    }

    return group
}

export const isCustomInputEveryoneCanEdit = (customMapping: CustomInputMapping | undefined): boolean => {
    return !!(customMapping && customMapping.isEveryoneCanEdit)
}

export const isDocumentEveryoneCanEdit = (doc: Document): boolean => {
    return doc.isEveryoneCanEdit
}
export const isDatatypeEditableForEveryone = (dataType: string, editableTypesForEveryone: string[]): boolean => {
    return editableTypesForEveryone.includes(dataType)
}